import { serializeQuery } from "@/utils/UrlUtils";
import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiSegments {
  static getSegments(appId, params, { signal } = {}) {
    let query = serializeQuery(params);
    if (query) query = `?${query}`;
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments${query}`, { signal });
  }

  static getSegment(appId, segId, params = {}) {
    let query = serializeQuery(params);
    if (query) query = `?${query}`;
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/${segId}${query}`);
  }

  static updateSegment(appId, segId, modelSegment) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/${segId}`, {
      method: "PUT",
      body: { segment: modelSegment },
    });
  }

  static deleteSegment(appId, segId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/${segId}`, {
      method: "DELETE",
    }).then(() => segId);
  }

  static setPrioritySegments(appId, segments) {
    const prioritizedSegments = segments.reduce((h, seg) => {
      return {
        ...h,
        [seg.id]: { priority: seg.priority },
      };
    }, {});
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/set_priority`, {
      method: "POST",
      body: { segments: prioritizedSegments },
    });
  }

  static createSegment(appId, modelSegment) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments`, {
      method: "POST",
      body: { segment: modelSegment },
    });
  }

  static getActivities(appId, segId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/${segId}/activity`);
  }

  static getSegmentModel(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/new`);
  }

  static bulkUpdate(appId, segments) {
    if (!segments?.length) throw new Error("Expected second parameter to be a non empty array");

    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/bulk_update`, {
      method: "PUT",
      body: { segments },
    });
  }

  static bulkDelete(appId, segments) {
    if (!segments?.length) throw new Error("Expected second parameter to be a non empty array");

    return apiFetch(`${ApiBaseUrl}apps/${appId}/segments/bulk_delete`, {
      method: "DELETE",
      body: { segments },
    });
  }
}
